import { translateObjectB4ToB2 } from 'utils/fm/fields';
import { getEntityTrueNameFromString } from 'utils/getEntityFromString';

import { COPILOT_TRANSFORMERS } from './transformers';

/**
 * Maps backend form payloads to CRUD data using the same pipeline as Copilot voice CRUD.
 */
export const getCrudDataFromBackendForm = (entityTrueName, form) => {
    if (!entityTrueName || !form) return null;

    const formEntity = getEntityTrueNameFromString(entityTrueName);
    if (!formEntity) return null;

    const translatedForm = translateObjectB4ToB2(formEntity, form);
    const transformer = COPILOT_TRANSFORMERS[entityTrueName];

    return transformer ? transformer(translatedForm) : translatedForm;
};
